// UI-компоненты (legacy):
import '../../components/ui/src/modal/modal.less'; // s-popup
import '../../components/ui/src/input/input.less'; // s-input
import '../../components/ui/src/button/button.less'; // s-button

import './common/feedback/index';



// WEBPACK FOOTER //
// ./src/feedback-entry.js